// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__eHEC1","modalFooterButton":"ModalNotes_modalFooterButton__27SkG"};